import StatusCell from '../../../elements/Table/Cells/StatusCell'
import React, { Component, Fragment } from 'react'
import { Button, Dropdown, Menu } from 'antd'
import { dateFormat, moneyColumn, strVal } from '../../../modules/Utils'
import InfoText from '../../../elements/InfoText'
import moment from 'moment/moment'
import Status from '../../../elements/Status'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import { streamUrl } from '../../../variables/index'
import ViewDownload from '../../../elements/ViewDownload'
import Authentication from '../../../modules/Authentication'
import CustomTable from '../../../elements/Table/CustomTable'

class List extends Component {
  auth = new Authentication()

  async componentDidMount() {
    await this.props.fetch()
  }

  columns = [
    {
      Header: 'Code',
      accessor: 'code',
      style: { textAlign: 'left' },
      Cell: ({ value, original }) => (
        <a
          target={'_blank'}
          href={`#/finance/statements/${strVal(original, '_id').replace('statements/', '')}/update`}
          style={{ marginLeft: '10px' }}>
          {value}
        </a>
      ),
      // Cell: ({original, value}) => {
      //   return <a onClick={e => this.props.onEdit(e, original)}>{value}</a>
      // },
    },
    {
      Header: 'No',
      accessor: 'no',
    },
    {
      Header: 'Start',
      accessor: 'period.start',
      Cell: ({ value }) => value && dateFormat(moment(value)),
    },
    {
      Header: 'End',
      accessor: 'period.end',
      Cell: ({ value }) => value && dateFormat(moment(value)),
    },
    {
      Header: 'Company',
      accessor: 'company.fn',
      width: 400,
    },
    {
      Header: 'Bank Account',
      accessor: 'bank.title',
      width: 250,
    },

    {
      Header: 'Currency',
      accessor: 'currency',
      Cell: ({ original, value }) => {
        try {
          return original.bank.bank.currency
        } catch (e) {
          return value ? value : original.bank ? original.bank : 'none'
        }
      },
    },
    {
      Header: 'Credit Amount',
      accessor: 'amount.credit',
      style: { textAlign: 'right' },
      Cell: ({ value }) => value && moneyColumn(value),
    },
    {
      Header: 'Debit Amount',
      accessor: 'amount.debit',
      style: { textAlign: 'right' },
      Cell: ({ value }) => value && moneyColumn(value),
    },
    {
      Header: 'Status',
      accessor: 'status',
      Cell: StatusCell,
    },
    {
      Header: 'File',
      accessor: 'file',
      Cell: ({ value }) =>
        value && (
          <ViewDownload
            view={`${streamUrl}files/${value}?action=view&access_token=${this.auth.getAccessToken()}`}
            download={`${streamUrl}files/${value}?action=download&access_token=${this.auth.getAccessToken()}`}
          />
        ),
    },
  ]

  render() {
    const { fetching, fetch, onShow, onChangeCompany, company, list } = this.props
    return (
      <Fragment>
        <CustomTable
          columns={this.columns.map(c => ({
            style: { textAlign: 'center' },
            ...c,
          }))}
          CreateButton={() => (
            <Fragment>
              <Button
                style={{ float: 'left' }}
                size={'small'}
                onClick={onShow}
                type={'primary'}
                icon={'plus'}>
                New{' '}
              </Button>
            </Fragment>
          )}
          fetch={fetch}
          ExtraOptionsButtons={props => (
            <OrganisationsSelect
              onChange={onChangeCompany}
              value={company}
              placeholder={'Filter by a company'}
              size={'small'}
              style={{ width: '450px', marginRight: 10 }}
              {...props}
            />
          )}
          data={list}
          loading={fetching}
          defaultPageSize={20}
        />
        <InfoText text={'Click on the ID to view and update Invoice'} />
        <InfoText text={'Tip: Hold shift when sorting to multi-sort!'} />
      </Fragment>
    )
  }
}

List.propTypes = {}
List.defaultProps = {
  fetching: false,
  fetch: () => console.error('Not Implemented'),
  list: [],
}

export default List
